import { supabase } from '../../../Utilities/SupabaseClient';

const getResponseCompletionDateFromDB = async (assessments, page, pageSize) => {
	console.log('assessments: ', assessments);

	if (!assessments || assessments.length === 0)
		return { completionDates: {}, total: 0 };

	page = Number(page);
	pageSize = Number(pageSize);

	console.log('page: ', page);
	console.log('pageSize: ', pageSize);

	const tableNames = [
		'supplier_initial_assessment_1',
		'supplier_initial_assessment_2',
		'supplier_scope1_assessment',
		'supplier_assessment_10004',
		'supplier_assessment_10005',
		'supplier_assessment_10006',
		'supplier_assessment_10007',
		'supplier_assessment_10008',
	];

	let allCompletionDates = [];

	// Fetch all data from different tables
	const results = await Promise.all(
		tableNames.map(async (tableName) => {
			const { data, error } = await supabase
				.from(tableName)
				.select('assessment_uuid, created_at')
				.in(
					'assessment_uuid',
					assessments.map((a) => a.assessment_uuid)
				);
			// .order('created_at', { ascending: sortDirection === 'asc' });

			if (error || !data) return []; // Return empty array on error
			return data;
		})
	);

	// Flatten results into a single array and remove duplicates
	allCompletionDates = results.flat().reduce((acc, record) => {
		if (
			!acc.some((entry) => entry.assessment_uuid === record.assessment_uuid)
		) {
			acc.push(record);
		}
		return acc;
	}, []);

	allCompletionDates.sort(
		(a, b) => new Date(b.created_at) - new Date(a.created_at)
	);

	console.log('allCompletionDates sorted:: ', allCompletionDates);


	const completionDatesArray = allCompletionDates
		.map(({ assessment_uuid, created_at }) => ({ assessment_uuid, created_at }))
		.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

	// Total records count (before pagination)
	const total = allCompletionDates.length;

	console.log('completionDates:: ', completionDatesArray);

	return { completionDatesArray, total };
};

export default getResponseCompletionDateFromDB;
